import React from 'react';

import parse from 'url-parse';
import Request from '../../model/Request';

import { Card } from 'antd';

import { Link } from 'react-router-dom';
// import TestType from '../../model/TestType';
import { convertDate, isNullOrUndefined } from '../../utils';
import { useTranslation } from '@nic-react-i18n/core';
import { useLocation, useParams } from 'react-router';
import { Bookings } from '../../model/Bookings';

export interface BreadcrumbItem {
    label: string;
    pathname: string;
    hideIntl?: boolean;

}

interface BreadcrumbInterface {
    itemList: Array<BreadcrumbItem>
    request?: Request
    bookings?: Bookings
}

interface PageHeaderInterface {
    request?: Request;
    breadcrumb: Array<BreadcrumbItem>;
    actions?: React.ReactElement<any>;
    bookings?: Bookings
}

type BreadcrumbProps = BreadcrumbInterface ;
export type PageHeaderProps = PageHeaderInterface & React.PropsWithChildren;

export interface UrlQueryInterface {
    request?: string;
    tests?: string;
    booking?: string;
}

const enabledBreadcrumbs: Record<string, any> = {
    Home: (query: UrlQueryInterface): boolean => { return true; },
    requests: (query: UrlQueryInterface): boolean => { return true; },
    request: (query: UrlQueryInterface): boolean => { return true; },
    tests: (query: UrlQueryInterface): boolean => { return true; },
    booking: (query: UrlQueryInterface): boolean => { return isNullOrUndefined(query.tests); },
};
/*
interface BreadcrumbLinkInterface {
    pathname: string;
    base: string;
    supportedKey: string;
   // request?: Request;
    showSeparator?: boolean;
    index?: number;
}
*/
//type BreadcrumbLinkProps = BreadcrumbLinkInterface & React.PropsWithChildren;

/*
const BreadcrumbLink: React.FC<BreadcrumbLinkProps> = (props) => {
    const {t} = useTranslation()
    const {pathname, base, supportedKey, showSeparator, index} = props;
    let show = (!isNullOrUndefined(showSeparator) ? showSeparator : 'true');

    //console.log('BreadcrumbLink: ', pathname, base, supportedKey, showSeparator, index)

    let component = <>{supportedKey}</>;
    return (
        <div>
            {show && <span style={{paddingLeft: '5px', paddingRight: '5px'}}>&gt;</span>}
                <Link
                    to={{
                        pathname: pathname,
                        search: base,
                    }}
                >
                    {component}
                </Link>
        </div>
    );
};
*/
const Breadcrumb: React.FC<BreadcrumbProps> = (props) => {
    const {itemList, request, bookings} = props;
    const pathParams = useParams()
    const {t, locale} = useTranslation()
    const location = useLocation()
    const {pathname, search} = location;
    const queryString = new URLSearchParams(search)

    let url = parse( pathname + search , true);
    //let booking = 'booking';
   // let indexString = !isNullOrUndefined(url.query[booking]) ? url.query[booking] : undefined;
   // let index: number | undefined = (indexString ? parseInt(indexString, 10) : undefined);
    //console.log('Breadcrumb: ', itemList, indexString, index)


    let keys = Object.keys(url.query);
    let supportedKeys: Array<string> = [];
    // Considero solamente i path supportati.
    keys.forEach((key: string) => {
        //   console.log('Key: ', key, enabledBreadcrumbs, enabledBreadcrumbs[key](enabledBreadcrumbs[key](url.query)));
        if (enabledBreadcrumbs[key]  && enabledBreadcrumbs[key](url.query)) {
            supportedKeys.push(key);
        }
    });

    const len = itemList.length;

    let component: Array<React.ReactElement<any>> = new Array<React.ReactElement<any>>();
    let i: number;
    for (i = 0; i < len - 1; i++) {
        const item = itemList[i];

        component.push(
            <div key={i}>
                <Link
                    to={item.pathname}
                >
                    {item.hideIntl ? item.label : t(`breadcrumb.${item.label}`)}
                </Link>
                <span style={{paddingLeft: '5px', paddingRight: '5px'}}>&gt;</span>
            </div>
        );
    }
    const last = itemList[i];

    component.push(
        <div key={i++}>
            <Link
                to={last.pathname}
            >
                {last.hideIntl ? last.label : t(`breadcrumb.${last.label}`)}
            </Link>
        </div>
    );

    //console.log('Breadcrumb: ', pathParams)

    if (pathParams.id !== undefined && request !== undefined) {
        component.push(
            <div key={i++}>
                <span style={{paddingLeft: '5px', paddingRight: '5px'}}>&gt;</span>
                <Link
                    to={{
                        pathname: pathname
                    }}
                >
                    {t(`test.${request.testType?.type}`)}
                </Link>

            </div>
        )
    }

    const bookingIdx = queryString.get('booking')


    if (bookingIdx !== null) {

        const idx = Number.parseInt(bookingIdx, 10)

        const bookInfo = bookings?.bookings[idx]
        //console.log('BookingInfo: ', bookInfo, bookings?.bookings[0].testDate.toDate())
        component.push(
        <div key={i++}>
            <span style={{paddingLeft: '5px', paddingRight: '5px'}}>&gt;</span>
            <Link
                to={{
                    pathname: pathname
                }}
            >
                <span>{convertDate(locale, bookInfo?.testDate !== undefined ? new Date(bookInfo?.testDate.toDate()): new Date())}</span>
            </Link>

        </div>
        )
    }


    return (
        <div
            style={{display: 'flex', flexWrap: 'wrap'}}
        >
            {component}
        </div>
    );
};

const PageHeader: React.FC<PageHeaderProps> = (props) => {
    const { breadcrumb, request, bookings} = props;
    //console.log('Header: ', props);

    let defaultBreadcrumb = [{label: 'Home', pathname: '/home'}] as Array<BreadcrumbItem>;

    let breadcrumbItems: Array<BreadcrumbItem> =
        ( !isNullOrUndefined(breadcrumb) ) ? breadcrumb : defaultBreadcrumb;

    let breadcrumbComponent =
        <Breadcrumb   itemList={breadcrumbItems} request={request} bookings={bookings}/>;

    return(
        <div style={{width: '100%'}}>
            <Card
                styles={{body: {
                    paddingTop: '5px',
                    paddingBottom: '5px',
                }}}
            >
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        flexWrap: 'wrap',
                    }}
                >
                    <div
                    >
                        {breadcrumbComponent}
                    </div>
                    <div>
                        {props.actions}
                    </div>
                </div>
            </Card>
            <div>
                {props.children}
            </div>
        </div>
    );
};
export default PageHeader